export type ValidationsDetailsCode =
  | "DuplicatedValueValidator"
  | "EmailValidator"
  | "EmptyValidator"
  | "EnumValidator"
  | "EqualValidator"
  | "ExclusiveBetweenValidator"
  | "GreaterThanOrEqualValidator"
  | "GreaterThanValidator"
  | "InclusiveBetweenValidator"
  | "LengthValidator"
  | "LessThanOrEqualValidator"
  | "LessThanValidator"
  | "NotEmptyValidator"
  | "NotEqualValidator"
  | "NotNullValidator"
  | "NullValidator"
  | "MaximumLengthValidator"
  | "MinimumLengthValidator"
  | "ScalePrecisionValidator";

export interface IErrorDetail {
  field: string;
  code: ValidationsDetailsCode;
  params: string[];
}

export interface INamekError {
  status: number;
  title: string;
  messages: string[];
  details?: IErrorDetail[];
  code: string;
}

export interface IErrorDetailRaw {
  Field: string;
  Code: ValidationsDetailsCode;
  Params: string[];
}
export interface INamekErrorRaw {
  Status: number;
  Title: string;
  Details?: IErrorDetailRaw[];
  Messages: string[];
  Code: string;
}

export type ResponseRawErrorT = {
  response: {
    data: INamekErrorRaw;
    status: number;
  };
};

export class NamekError implements INamekError {
  public status: number = 0;
  public title: string = "";
  public messages: string[] = [];
  public details: IErrorDetail[] | undefined = [];
  public code: string = "";

  constructor(props: Partial<INamekError> | Partial<INamekErrorRaw>) {
    if (!props) {
      return;
    }

    if ("Status" in props) {
      this.status = props?.Status ?? 0;
      this.title = props?.Title ?? "";
      this.messages = props?.Messages ?? [];
      this.details = props.Details?.map((detail) => ({
        field: detail?.Field ?? "",
        code: detail?.Code ?? "",
        params: detail?.Params ?? [],
      }));
      this.code = props?.Code ?? "";
    } else if ("status" in props) {
      this.status = props?.status ?? 0;
      this.title = props?.title ?? "";
      this.messages = props?.messages ?? [];
      this.details = props?.details;
      this.code = props?.code ?? "";
    }

    if (this.status === 500 && this.title === "Error") {
      this.title = "Error inesperado";
    }
  }
}

export const isOfflineError = (error: unknown): boolean => {
  // @ts-expect-error TODO: solucionar el tipado unknown
  return error instanceof OfflineError || error?.code === "ERR_NETWORK";
};

export class OfflineError extends NamekError {
  public status: number = 0;
  public title: string = "";
  public messages: string[] = [];
  public code: string = "ERR_NETWORK";
}
